import { Component, OnInit } from '@angular/core';
import { InputWidget } from '../input-widget';

@Component({
  selector: 'app-boolean',
  templateUrl: './boolean.component.html',
  styleUrls: ['./boolean.component.scss'],
})
export class BooleanComponent extends InputWidget {

  static componentName = 'BooleanComponent';

  constructor() {
   super();
  }

  setValue(val){
    if (typeof val === 'string'){
      val = val.toLowerCase();
      this._value = (val === 'true');
    }
    else{
      this._value = val;
    }
  }
}
